import { render } from "./ToolbarSpacer.vue?vue&type=template&id=6e24e382"
const script = {}

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Toolbar/ToolbarSpacer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e24e382"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e24e382', __exports__)) {
    console.log('reload')
    api.reload('6e24e382', __exports__)
  }
  
  module.hot.accept("./ToolbarSpacer.vue?vue&type=template&id=6e24e382", () => {
    console.log('re-render')
    api.rerender('6e24e382', render)
  })

}


export default __exports__